<ng-container [ngSwitch]="link.user.type">
  <ng-container *ngSwitchCase="ObjectType.TwinoidUser">
    <a [routerLink]="['', 'archive', 'twinoid', 'users', link.user.id]">
      <span class="icon"><img src="assets/login-methods/twinoid.png"/></span>
      <strong>{{link.user.displayName}}</strong>
      <em>twinoid.com</em>
    </a>
    <span class="actions" *ngIf="isAdministrator$ | async">
        <etwin-unlink-twinoid-button [userId]="userId" [twinoidUserId]="link.user.id"></etwin-unlink-twinoid-button>
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="ObjectType.DinoparcUser">
    <a [routerLink]="['', 'archive', 'dinoparc', link.user.server, 'users', link.user.id]">
      <span class="icon"><img src="assets/login-methods/dinoparc.png"/></span>
      <strong>{{link.user.username}}</strong>
      <em>{{link.user.server}}</em>
    </a>
    <span class="actions" *ngIf="isAdministrator$ | async">
        <etwin-unlink-dinoparc-button [userId]="userId" [dinoparcServer]="link.user.server" [dinoparcUserId]="link.user.id"></etwin-unlink-dinoparc-button>
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="ObjectType.HammerfestUser">
    <a [routerLink]="['', 'archive', 'hammerfest', link.user.server, 'users', link.user.id]">
      <span class="icon"><img src="assets/login-methods/hammerfest.png"/></span>
      <strong>{{link.user.username}}</strong>
      <em>{{link.user.server}}</em>
    </a>
    <span class="actions" *ngIf="isAdministrator$ | async">
        <etwin-unlink-hammerfest-button [userId]="userId" [hammerfestServer]="link.user.server" [hammerfestUserId]="link.user.id"></etwin-unlink-hammerfest-button>
    </span>
  </ng-container>
  <ng-container *ngSwitchDefault>
    {{link | json}}
  </ng-container>
</ng-container>
